module.exports = __webpack_public_path__ + "static/media/tigres.40ce4504.png";